import Moment from 'moment';
import { ActionTypes } from '../constants';

const defaults = {
  menu: {},
  checks: [],
  logs: [],
};

export interface RethinkState {
  menu: {
    categories: Array<any>,
  };
}

export interface ActionType {
  type: string;
  payload: any;
}

export default (state: RethinkState = defaults, action: ActionType) => {
  switch (action.type) {
    case ActionTypes.MENU_UPDATE: {
      console.info('new menu', action.payload);
      return {
        ...state,
        ...action.payload,
      };
    }
    case ActionTypes.RETHINK_UPDATE_CHECKS: {
      const { checks } = action.payload;
      return {
        ...state,
        checks,
      };
    }
    case ActionTypes.RETHINK_CLEAR_CHECKS: {
      return {
        ...state,
        checks: [],
      };
    }
    case ActionTypes.RETHINK_ADD_LOG: {
      const { logs } = state;
      const { log } = action.payload;
      const newLines = [...logs];
      if (logs.length >= 100) {
        newLines.splice(0, 1);
      }
      const formattedLine = `${Moment(new Date()).format('YYYY-MM-DD HH:mm:ss')} - ${
        log.logLevel
      } - ${log.message}`;
      return {
        ...state,
        logs: newLines.concat(formattedLine),
      };
    }
    case ActionTypes.RETHINK_CLEAR_LOGS: {
      return {
        ...state,
        logs: [],
      };
    }
    default:
      return { ...state };
  }
};
